export const MODAL_COUNT_KEY = '_MdLcnT';

export interface Poll {
  id: number;
  answers?: Answer[];
  title?: string;
  question?: string;
  is_active?: boolean;
}

export interface Answer {
  id: number;
  answer_text: string;
  poll: number;
}

export interface PollResults {
  poll?: number;
  answers?: number[];
  custom_answer?: string;
}



// WEBPACK FOOTER //
// ./src/app/entity/poll.ts